import React from 'react';
import { geocodeByAddress } from 'react-places-autocomplete';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import MapSelectorView from '../../InlineEditorWizard/MapSelector/MapSelectorView';
import { LocalizationContext } from '../../../hoc/Localization';
import { LocationContext } from '../../../hoc/Location';
import { SettingsContext } from '../../../hoc/Settings';
import AddressComp from '../../InlineEditor/AddressComp';
import StepContainer from '../StepContainer';
import localStyles from './styles.less';

const SchoolLocation = () => {
  const { t } = React.useContext(LocalizationContext);
  const { edited, updateContent, step } = React.useContext(EditorWizardContext);

  const { location } = edited;

  const setValue = data => {
    updateContent('location', data);
  };

  const { countries } = React.useContext(LocationContext);
  const {
    domainSettings: { region },
  } = React.useContext(SettingsContext);

  const [locationCreateMode, setLocationCreateMode] = React.useState(false);
  const [validations, setValidations] = React.useState({
    city: true,
    street: true,
    houseNumber: true,
  });

  let address = [];
  if (location) {
    address = [location.city, location.street];
    if (location.house_number) {
      address.push(location.house_number);
    }
  }

  const formatAddress = React.useCallback(result => {
    const latLng = {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
    };

    const { address_components: addressComponents } = result;
    const { houseNumber, street, city, zipCode, country } = AddressComp(addressComponents);

    return {
      ...latLng,
      city,
      street,
      country,
      zip_code: zipCode,
      house_number: houseNumber,
    };
  }, []);

  const handleLocationSelect = React.useCallback(
    async data => {
      const fetchedLocation = formatAddress(data);

      if (countries.includes(fetchedLocation.country)) {
        setValue(fetchedLocation);
      }
    },
    [formatAddress, setValue],
  );

  const onMapPositionChange = React.useCallback(
    event => {
      const {
        center: { lat, lng },
      } = event;
      setValidations({
        city: true,
        street: true,
        houseNumber: true,
      });

      if (!locationCreateMode && window.google) {
        // eslint-disable-next-line
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ location: { lat, lng }, region }, res => {
          if (res && res.length) {
            handleLocationSelect(res[0]);
          }
        });
      } else {
        setValue({
          ...location,
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        });
      }
    },
    [handleLocationSelect, locationCreateMode, location],
  );

  const handleLocationChange = React.useCallback(
    async data => {
      const fetchedAddresses = await geocodeByAddress(data);
      const result = fetchedAddresses[0];

      const fetchedLocation = formatAddress(result);

      setValue(fetchedLocation);
    },
    [formatAddress, setValue],
  );

  const changeField = React.useCallback(
    (name, item) => {
      setValue({
        ...location,
        [name]: item,
      });
    },
    [location, setValue],
  );

  const { street, city, houseNumber } = validations;

  return (
    <StepContainer nextButtonDisabled={!location || !location.house_number} step={step}>
      <div className={localStyles.wrapper}>
        <MapSelectorView
          street={street}
          city={city}
          value={location}
          houseNumber={houseNumber}
          changeField={changeField}
          handleLocationChange={handleLocationChange}
          onMapPositionChange={onMapPositionChange}
          locationCreateMode={locationCreateMode}
          setLocationCreateMode={setLocationCreateMode}
          classname="mapWizard"
          t={t}
        />
      </div>
    </StepContainer>
  );
};

export default SchoolLocation;
